import { render, staticRenderFns } from "./SCardPersonalControlComp.vue?vue&type=template&id=2a960422&"
import script from "./SCardPersonalControlComp.vue?vue&type=script&lang=js&"
export * from "./SCardPersonalControlComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports